export default __webpack_public_path__ + "static/media/Mic-Icon.6af4cb08.png";